import type { PotSummaryDto } from '../api/potsApi';
import type { PotSummary } from '../types/pot.types';

interface PeriodInfo {
  year: number;
  weekNumber: number;
  start: string;
  end: string;
}

/**
 * Convert API DTO to PotSummary type for table display
 */
export function convertToTablePot(
  dto: PotSummaryDto,
  period: PeriodInfo
): PotSummary {
  return {
    id: dto.id,
    owner: {
      type: dto.ownerType,
      name: dto.ownerName,
    },
    period: {
      year: period.year,
      weekNumber: period.weekNumber,
      start: period.start,
      end: period.end,
    },
    status: dto.status as PotSummary['status'],
    netAmount: dto.netAmount,
    nextDeadline: {
      date: dto.nextDeadline,
      type: dto.nextDeadlineType,
    },
    isScheduledForAutoSubmit: dto.isScheduledForAutoSubmit,
    isPrimary: dto.isPrimary,
  };
}
